import useFatnessInfoForGraph from 'hook/query/useFatnessInfoForGraph'
import moment from 'moment'
import { CardStandart } from 'ui/CardStandart'
import Preloader from 'ui/Preloader'

import { ExpiredLicense } from 'ui/expired-license/ExpiredLicense'
import FatnessChart from '../shared/FatnessChart'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

const FatnessCard = props => {
	const { activeFilter } = props

	const {
		normalCategories,
		deviationCategories,
		obesityCategories,
		emaciationCategories,
		timestamp,
		onChangeCallback,
		dateRange,
		isLoading,
		error,
		shouldAggregateMonthly,
	} = useFatnessInfoForGraph({ groupId: activeFilter })

	return (
		<CardStandart
			sx={{
				padding: '24px',
				display: 'flex',
				flexDirection: 'column',
				gap: '24px',
				minHeight: '350px',
			}}
		>
			<TypographyHeader>Упитанность</TypographyHeader>
			<DateRangePicker
				onChangeUpdateDate={onChangeCallback}
				monthFilter={true}
				yearFilter={true}
				currentRange={'Месяц'}
				startDate={dateRange.startDate}
				endDate={dateRange.endDate}
			/>
			{isLoading ? (
				<Preloader mt={6} />
			) : error?.response?.status === 450 ? (
				<ExpiredLicense
					mt={'80px'}
					availableLicenceDates={`Доступен просмотр данных за период ${moment(
						error?.response.data.detail.start_dt,
					).format('DD.MM.YY')} - ${moment(
						error?.response.data.detail.until_dt,
					).format('DD.MM.YY')}`}
				/>
			) : (
				<FatnessChart
					normalCategories={normalCategories}
					deviationCategories={deviationCategories}
					obesityCategories={obesityCategories}
					emaciationCategories={emaciationCategories}
					timestamp={timestamp}
					shouldUseCategoryAxis={shouldAggregateMonthly}
					startDate={dateRange.startDate}
					endDate={dateRange.endDate}
				/>
			)}
		</CardStandart>
	)
}

export default FatnessCard
